module.exports = __webpack_public_path__ + "img/lg_ring_g_o_1_0.d0185497.png";